<p>{{ filtersChannel?.channelName }} {{ filtersChannel?.uuid }}</p>